class ToggleCollapse {
    constructor(root) {
        const target = document.querySelector('#' + root.dataset.toggleCollapse);

        if (!target) {
            return;
        }

        this.calculateHeight(target);

        root.addEventListener('click', this.toggle.bind(null, root, target));

        window.addEventListener('resize', this.calculateHeight.bind(null, target));
    }

    calculateHeight(target) {
        target.style.setProperty('max-height', 'none');
        target.style.setProperty('--height', target.offsetHeight + 'px');
        target.style.removeProperty('max-height');
    }

    toggle(root, target, event) {
        event.preventDefault();

        if (root.getAttribute('aria-expanded') === 'true') {
            root.removeAttribute('aria-expanded');
            target.setAttribute('hidden', '');
        } else {
            root.setAttribute('aria-expanded', 'true');
            target.removeAttribute('hidden');
        }
    }
}

(function () {
    'use strict';

    const elements = document.querySelectorAll('[data-toggle-collapse]');

    for (const element of elements) {
        new ToggleCollapse(element);
    }
})();
